import { render } from "./TriadUsersListComponent.vue?vue&type=template&id=5b43da9c&scoped=true"
import script from "./TriadUsersListComponent.vue?vue&type=script&lang=js"
export * from "./TriadUsersListComponent.vue?vue&type=script&lang=js"

import "./TriadUsersListComponent.vue?vue&type=style&index=0&id=5b43da9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b43da9c"]])

export default __exports__